function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("style", null, ".cls-1{stroke-width:0px;}"));

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  id: "_004-brush"
}, React.createElement("path", {
  id: "_002-watch",
  className: "cls-1",
  d: "m12.78,3.82s-1.52-.59-1.52-.59l-.45-2.81C10.77.17,10.57,0,10.33,0H3.69c-.24,0-.45.17-.48.41l-.45,2.81s-1.5.58-1.52.59c-.72.2-1.22.84-1.24,1.59v10.76c.05.76.58,1.4,1.31,1.6h0l1.44.55.45,2.81c.04.24.24.41.48.41h6.63c.24,0,.45-.17.48-.41l.45-2.81,1.45-.56c.73-.2,1.26-.84,1.31-1.6v-2.97h.61v-1.85h-.61v-1.94h.61v-1.85h-.61v-2.15c-.04-.74-.54-1.37-1.25-1.59Zm-.33,11.44c0,.53-.43.96-.96.96H2.53c-.53,0-.96-.43-.96-.96h0V6.3c0-.53.43-.96.96-.96h8.96c.53,0,.96.43.96.96h0v8.96h0Z"
}));

var SvgGarmin = function SvgGarmin(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "Layer_2",
    viewBox: "0 0 14.63 21.53",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgGarmin, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Garmin.7f70a538.svg";
export { ForwardRef as ReactComponent };